<template>
    <div class="md-layout-item md-elevation-0"> 

        <md-card class="md-elevation-1 m-5">

          <md-card-header class="md-layout md-alignment-center-left justify header-bg">
          Solicitud de Suscripción Adicional
          </md-card-header> 
        

          <md-card-content>
            <div>
                <p align="justify">
                    Bienvenido al proceso de suscripción inicial de los fondos mutuos de Faro Capital. Agradeceremos completar toda la información solicitada. ¡Muchas gracias!
                </p>
                
            </div>
            <div>
                <img src="@/assets/faro.png"/>
            </div>
              
          </md-card-content>

        </md-card>

        <div class="md-alignment-center-left justify">
          <md-button class="md-raised" @click="Next">Siguiente</md-button>  
        </div>        

    </div>
</template>

<script>
export default {
    name:"Form0",
    props:["title"],
    data: () => ({
        form:{
        }
    }),    
    mounted:function(){

    },
    methods:{
        Next(){

            this.$emit('setDone', {id: "0", index: 1})
        }
    }
}
</script>